import { HStack, PinInput, PinInputField } from '@chakra-ui/react'

interface Props {
  value: string
  onChange: (value: string) => void
  isDisabled?: boolean
}

export default function OTPInput({ value, onChange, isDisabled }: Props) {
  return (
    <HStack justify='center' spacing={3}>
      <PinInput
        value={value}
        onChange={onChange}
        type='number'
        size='lg'
        isDisabled={isDisabled}
        otp
        autoFocus
      >
        <PinInputField
          w='60px'
          h='70px'
          fontSize='2xl'
          fontWeight='bold'
          borderColor='gray.300'
          _hover={{ borderColor: 'purple.400' }}
          _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple' }}
        />
        <PinInputField
          w='60px'
          h='70px'
          fontSize='2xl'
          fontWeight='bold'
          borderColor='gray.300'
          _hover={{ borderColor: 'purple.400' }}
          _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple' }}
        />
        <PinInputField
          w='60px'
          h='70px'
          fontSize='2xl'
          fontWeight='bold'
          borderColor='gray.300'
          _hover={{ borderColor: 'purple.400' }}
          _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple' }}
        />
        <PinInputField
          w='60px'
          h='70px'
          fontSize='2xl'
          fontWeight='bold'
          borderColor='gray.300'
          _hover={{ borderColor: 'purple.400' }}
          _focus={{ borderColor: 'purple.500', boxShadow: '0 0 0 1px purple' }}
        />
      </PinInput>
    </HStack>
  )
}
